import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  lazy,
  Suspense,
} from "react";
import {
  Typography,
  Tooltip,
  Box,
  Modal,
  Stack,
  Card,
  CardContent,
  InputBase,
  IconButton,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Button,
  useMediaQuery,
  CircularProgress,
  AppBar,
  Toolbar,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import LanguageIcon from "@mui/icons-material/Language";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import DirectionsWalkOutlinedIcon from "@mui/icons-material/DirectionsWalkOutlined";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import DoneAllOutlinedIcon from "@mui/icons-material/DoneAllOutlined";
import { styled } from "@mui/system";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import Navbar from "../../../Navbar";
import Footer from "../../../Footer";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import CloseIcon from "@mui/icons-material/Close";
import Followup from "../Enquiries/ActionComponent/Followup";
import PatientView from "../Viewservice/PatientView";
import CallerView from "../Viewservice/CallerView";
import { API_URL } from "../../Config/api";

// Lazy loaded Package Component
const PackageServiceTable = lazy(() => import("./PackageServiceTable"));

// 🔴 ADDED: minWidth for table responsive horizontal scroll
const ServiceCard = styled(Card)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  marginTop: "10px",
  backgroundColor: "white",
  boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
  height: "54px",
  borderRadius: "10px",
  transition: "0.5s ease-in-out",
  minWidth: "1000px",
});

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90%", sm: 400 }, // Responsive modal
  bgcolor: "background.paper",
  border: "2px solid #000",
  pt: 2,
  px: { xs: 2, sm: 4 },
  pb: 3,
};

const ITEM_HEIGHT = 48;

const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

const getCallerStatusTooltip = (callerStatus) => {
  const icon =
    callerStatus === 1 ? (
      <SmartphoneIcon style={{ color: "#EB8793" }} />
    ) : callerStatus === 2 ? (
      <LanguageIcon style={{ color: "#7AB7EE" }} />
    ) : callerStatus === 3 ? (
      <DirectionsWalkOutlinedIcon style={{ color: "#84CDB1" }} />
    ) : callerStatus === 4 ? (
      <CallOutlinedIcon style={{ color: "#8D9BED" }} />
    ) : callerStatus === 5 ? (
      <DoneAllOutlinedIcon style={{ color: "#8D9BED" }} />
    ) : (
      <ErrorOutlineIcon style={{ color: "#EB8793" }} />
    );
  return <IconButton>{icon}</IconButton>;
};

const ServiceRequest = () => {
  const navigate = useNavigate();
  const accessToken = localStorage.getItem("token");
  const accessHospitalID = localStorage.getItem("hospitalID") || 0;

  const [selected, setSelected] = useState("service");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [serviceRequest, setServiceRequest] = useState([]);
  const [tableHeight, setTableHeight] = useState("auto");
  const [loading, setLoading] = useState(true);

  const [clrName, setclrName] = useState("");
  const [callerNumber, setcallerNumber] = useState("");
  const [callerId, setcallerID] = useState("");
  const [caller, setCaller] = useState("");
  const [patientID, setPatientID] = useState(null);
  const [patient, setPatient] = useState("");
  const [hospital, setHospital] = useState("");
  const [callerData, setCallerData] = useState({
    name: "",
    number: "",
    eventID: "",
    callerID: "",
  });

  const [eventID, setEventID] = useState("");
  const [paydone, setPaydone] = useState();
  const [requestAllocation, setRequestAllocation] = useState({});
  const [flagValue, setFlagValue] = useState(null);

  const [selectedDate, setSelectedDate] = useState("");
  const [selectedService, setSelectedService] = useState("");
  const [selectedCallerStatus, setSelectedCallerStatus] = useState("");

  const [openPatientDetails, setOpenPatientDetails] = useState(false);
  const [openDetails, setopenDetails] = useState(false);
  const [open1, setOpen1] = useState(false);

  const [preFollowup, setPreFollowup] = useState([]);
  const [enqID, setEnqID] = useState("");
  const [enq, setEnq] = useState([]);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const isSmallScreen = useMediaQuery("(max-width:900px)"); // Adjusted breakpoint

  const handleChangeToggle = useCallback((event, newAlignment) => {
    if (newAlignment !== null) {
      setSelected(newAlignment);
      setPage(0);
    }
  }, []);

  const handleOpenPatientDetails = useCallback(
    () => setOpenPatientDetails(true),
    [],
  );
  const handleClosePatientDetails = useCallback(
    () => setOpenPatientDetails(false),
    [],
  );
  const handleCloseDetails2 = useCallback(() => setopenDetails(false), []);
  const handleOpen1 = useCallback(() => setOpen1(true), []);
  const handleClose1 = useCallback(() => setOpen1(false), []);
  const handleClick = useCallback(
    (event) => setAnchorEl(event.currentTarget),
    [],
  );
  const handleClose = useCallback(() => setAnchorEl(null), []);

  const handleDateChange = useCallback((e) => {
    setSelectedDate(e.target.value);
    setPage(0);
  }, []);

  const handleServiceChange = useCallback((e) => {
    setSelectedService(e.target.value);
    setPage(0);
  }, []);

  const handleChangePage = useCallback(
    (event, newPage) => setPage(newPage),
    [],
  );
  const handleChangeRowsPerPage = useCallback((event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  }, []);

  const patientIDRequest = useCallback(
    (id) => {
      setPatientID(id);
      handleOpenPatientDetails();
    },
    [handleOpenPatientDetails],
  );

  const handleOpenDetails2 = useCallback((row) => {
    const data = {
      phone: row?.agg_sp_pt_id?.caller_phone_number || "Unknown",
      eventID: row?.eve_id || "",
      callerID: row?.agg_sp_pt_id?.caller_id || "Unknown",
    };
    setCallerData(data);
    setopenDetails(true);
  }, []);

  const findPreFollowupRecords = useCallback((eveId) => setEnqID(eveId), []);

  const getPatientDetails = useCallback(async () => {
    if (!patientID) return;
    try {
      const res = await fetch(
        `${API_URL}/web/patient_detail_info_api/${patientID}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        },
      );
      const data = await res.json();
      setPatient(data.patient);
      setHospital(data.hospital);
    } catch (error) {
      console.error("Error fetching patient details:", error);
    }
  }, [patientID, accessToken]);

  const getRequestAllocation = useCallback(
    async (a, currentEventID, currentFlag) => {
      if (currentEventID) {
        try {
          const res = await fetch(
            `${API_URL}/web/agg_hhc_srv_req_prof_allocate/${currentEventID}`,
            {
              headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
              },
            },
          );
          const data = await res.json();
          setRequestAllocation(data);
          navigate("/viewservice", {
            state: {
              patientID: data.patient_details.agg_sp_pt_id,
              callerID: data.caller_details.caller_id,
              eventPlanID: data.POC[0].eve_poc_id,
              eventID: data.Event_ID,
              flag: currentFlag,
              paymentStatus: a,
              ServicetoEnquiry: 1,
            },
          });
        } catch (error) {
          console.error("Error fetching Request Allocation:", error);
        }
      }
    },
    [accessToken, navigate],
  );

  const getEventIDRequest = useCallback(
    (eveId, paydone, isPkg = false) => {
      const selectedRequest = serviceRequest.find(
        (item) => item.event_id === eveId,
      );
      if (selectedRequest) {
        setEventID(selectedRequest.event_id);
        setPatientID(selectedRequest.agg_sp_pt_id?.agg_sp_pt_id);
        setFlagValue(selectedRequest.flag);
        setPaydone("ac");
        getRequestAllocation(
          selectedRequest.payment_is_done,
          selectedRequest.event_id,
          selectedRequest.flag,
        );
      }
    },
    [serviceRequest, getRequestAllocation],
  );

  const EventIDRequest = useCallback(
    (eveId) => {
      const selectedRequest = serviceRequest.find(
        (item) => item.event_id === eveId,
      );
      setEnqID(eveId);
      if (selectedRequest) {
        setEventID(selectedRequest.event_id);
        setFlagValue(selectedRequest.flag);
        setcallerID(selectedRequest.caller_id);
        setclrName(selectedRequest.caller_name);
        setcallerNumber(selectedRequest.caller_phone_number);
      }
    },
    [serviceRequest],
  );

  const getPackageRequestAllocation = useCallback(
    async (row) => {
      if (!row?.event_id) return;
      try {
        const res = await fetch(
          `${API_URL}/web/agg_hhc_srv_req_prof_allocate/${row.event_id}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        );
        const data = await res.json();
        setRequestAllocation(data);

        // 🔴 Yahan hum isPackage: true bhej rahe hain
        navigate("/viewservice", {
          state: {
            patientID: data.patient_details.agg_sp_pt_id,
            callerID: data.caller_details.caller_id,
            eventPlanID: data.POC[0]?.eve_poc_id,
            eventID: data.Event_ID,
            isPackage: true, // 🔴 Flag yahan set hai
            flag: row.flag,
            paymentStatus: row.payment_is_done,
            ServicetoEnquiry: 1,
          },
        });
      } catch (error) {
        console.error("Error fetching Package Allocation:", error);
      }
    },
    [accessToken, navigate],
  );

  // 🔴 PACKAGE: Followup — reuses existing Followup modal + state
  const handlePackageFollowup = useCallback(
    (row) => {
      if (!row?.event_id) return;
      setEnqID(row.event_id);
      setEventID(row.event_id);
      setcallerID(row.caller_id);
      setclrName(row.caller_name);
      setcallerNumber(row.caller_phone_number);
      handleOpen1();
    },
    [handleOpen1],
  );

  useEffect(() => {
    if (patientID !== null) getPatientDetails();
  }, [patientID, getPatientDetails]);

  useEffect(() => {
    const getServiceRequest = async () => {
      try {
        const res = await fetch(
          `${API_URL}/web/service_request/${accessHospitalID}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        );
        const data = await res.json();
        setServiceRequest(data.event_code || []);
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setLoading(false);
      }
    };
    getServiceRequest();
  }, [accessHospitalID, accessToken]);

  useEffect(() => {
    const getPreFollowup = async () => {
      if (!enqID) return;
      try {
        const res = await fetch(
          `${API_URL}/web/previous_follow_up/2/${enqID}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        );
        const data = await res.json();
        setPreFollowup(data);
      } catch (error) {
        console.error("Error:", error);
      }
    };
    getPreFollowup();
  }, [enqID, accessToken]);

  useEffect(() => {
    const updateTableHeight = () => setTableHeight(`${window.innerHeight}px`);
    updateTableHeight();
    window.addEventListener("resize", updateTableHeight);
    return () => window.removeEventListener("resize", updateTableHeight);
  }, []);

  const filteredData = useMemo(() => {
    return (serviceRequest || []).filter((item) => {
      const isDateMatch =
        !selectedDate ||
        (item?.event_start_date &&
          item.event_start_date.includes(selectedDate));
      const isServiceMatch =
        !selectedService ||
        (item?.service_name &&
          item.service_name
            .toLowerCase()
            .includes(selectedService.toLowerCase()));
      const isCallerStatusMatch =
        !selectedCallerStatus ||
        selectedCallerStatus === 5 ||
        item?.caller_status === selectedCallerStatus;
      return isDateMatch && isServiceMatch && isCallerStatusMatch;
    });
  }, [serviceRequest, selectedDate, selectedService, selectedCallerStatus]);

  const paginatedData = useMemo(() => {
    return filteredData.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage,
    );
  }, [filteredData, page, rowsPerPage]);

  return (
    <>
      <Navbar />
      <Box
        sx={{ flexGrow: 1, mt: 13, ml: 1, mr: 1, mb: 4, overflow: "hidden" }}
      >
        {/* 🔴 RESPONSIVE TOP BAR */}
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={2}
          alignItems={{ xs: "stretch", md: "center" }}
          sx={{ pt: 1, mb: 2 }}
        >
          <Typography
            style={{ fontSize: 16, fontWeight: 600, paddingLeft: "10px" }}
            color="rgb(162, 119, 169)"
          >
            {selected === "service" ? "SERVICE REQUESTS" : "PACKAGE REQUESTS"}
          </Typography>

          <Box
            component="form"
            sx={{
              display: "flex",
              alignItems: "center",
              width: { xs: "100%", md: 250 },
              height: "2.5rem",
              backgroundColor: "#ffffff",
              boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
              borderRadius: "10px",
              border: "1px solid #C9C9C9",
            }}
          >
            <InputBase
              sx={{ ml: 1, mr: 1, flex: 1 }}
              type="date"
              value={selectedDate}
              onChange={handleDateChange}
            />
          </Box>

          <Box
            component="form"
            sx={{
              display: "flex",
              alignItems: "center",
              width: { xs: "100%", md: 280 },
              height: "2.5rem",
              backgroundColor: "#ffffff",
              boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
              borderRadius: "10px",
              border: "1px solid #C9C9C9",
            }}
          >
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder="Search Service |"
              value={selectedService}
              onChange={handleServiceChange}
            />
            <IconButton type="button" sx={{ p: "10px" }}>
              <SearchIcon style={{ color: "#7AB7EE" }} />
            </IconButton>
          </Box>

          <Box
            component="form"
            sx={{
              display: "flex",
              alignItems: "center",
              width: { xs: "100%", md: 320 },
              height: "2.5rem",
              backgroundColor: "#ffffff",
              boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
              borderRadius: "10px",
              border: "1px solid #C9C9C9",
            }}
          >
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder="View Request by |"
              readOnly
            />
            <IconButton onClick={() => setSelectedCallerStatus(1)}>
              <SmartphoneIcon style={{ color: "#EB8793" }} />
            </IconButton>
            <IconButton onClick={() => setSelectedCallerStatus(2)}>
              <LanguageIcon style={{ color: "#7AB7EE" }} />
            </IconButton>
            <IconButton onClick={() => setSelectedCallerStatus(3)}>
              <DirectionsWalkOutlinedIcon style={{ color: "#84CDB1" }} />
            </IconButton>
            <IconButton onClick={() => setSelectedCallerStatus(4)}>
              <CallOutlinedIcon style={{ color: "#8D9BED" }} />
            </IconButton>
            <IconButton onClick={() => setSelectedCallerStatus(5)}>
              <DoneAllOutlinedIcon style={{ color: "#F6900D" }} />
            </IconButton>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: { xs: "center", md: "flex-end" },
              flex: 1,
            }}
          >
            <ToggleButtonGroup
              value={selected}
              exclusive
              onChange={handleChangeToggle}
              sx={{
                "& .MuiToggleButton-root": {
                  height: 40,
                  minWidth: 100,
                  textTransform: "capitalize",
                  fontWeight: 600,
                },
                "& .Mui-selected": {
                  backgroundColor: "rgb(237, 204, 242) !important",
                  color: "#000 !important",
                },
              }}
            >
              <ToggleButton value="service">Service</ToggleButton>
              <ToggleButton value="package">Package</ToggleButton>
            </ToggleButtonGroup>
          </Box>
        </Stack>

        {selected === "service" ? (
          <>
            <TableContainer
              sx={{
                height: filteredData.length < 5 ? "40vh" : "auto",
                overflowX: "auto",
              }}
            >
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <ServiceCard
                      style={{
                        background: "rgb(237, 204, 242)",
                        borderRadius: "8px 10px 0 0",
                        height: "3rem",
                      }}
                    >
                      <CardContent
                        style={{
                          flex: "0.8",
                          borderRight: "1px solid #FFFFFF",
                          textAlign: "center",
                        }}
                      >
                        <Typography variant="subtitle2">Sr. No</Typography>
                      </CardContent>
                      <CardContent
                        style={{
                          flex: "1",
                          borderRight: "1px solid #FFFFFF",
                          textAlign: "center",
                        }}
                      >
                        <Typography variant="subtitle2">Source</Typography>
                      </CardContent>
                      <CardContent
                        style={{
                          flex: "2",
                          borderRight: "1px solid #FFFFFF",
                          textAlign: "center",
                        }}
                      >
                        <Typography variant="subtitle2">Event Code</Typography>
                      </CardContent>
                      <CardContent
                        style={{
                          flex: "1.8",
                          borderRight: "1px solid #FFFFFF",
                          textAlign: "center",
                        }}
                      >
                        <Typography variant="subtitle2">
                          Patient Name
                        </Typography>
                      </CardContent>
                      <CardContent
                        style={{
                          flex: "1.8",
                          borderRight: "1px solid #FFFFFF",
                          textAlign: "center",
                        }}
                      >
                        <Typography variant="subtitle2">
                          Patient Mobile
                        </Typography>
                      </CardContent>
                      <CardContent
                        style={{
                          flex: "1.8",
                          borderRight: "1px solid #FFFFFF",
                          textAlign: "center",
                        }}
                      >
                        <Typography variant="subtitle2">
                          Caller Mobile
                        </Typography>
                      </CardContent>
                      <CardContent
                        style={{
                          flex: "2.8",
                          borderRight: "1px solid #FFFFFF",
                          textAlign: "center",
                        }}
                      >
                        <Typography variant="subtitle2">
                          Service Name
                        </Typography>
                      </CardContent>
                      <CardContent
                        style={{
                          flex: "2",
                          borderRight: "1px solid #FFFFFF",
                          textAlign: "center",
                        }}
                      >
                        <Typography variant="subtitle2">Start Date</Typography>
                      </CardContent>
                      <CardContent
                        style={{
                          flex: "1",
                          borderRight: "1px solid #FFFFFF",
                          textAlign: "center",
                        }}
                      >
                        <Typography variant="subtitle2">Zone</Typography>
                      </CardContent>
                      <CardContent style={{ flex: "1", textAlign: "center" }}>
                        <Typography variant="subtitle2">Action</Typography>
                      </CardContent>
                    </ServiceCard>
                  </TableRow>
                </TableHead>

                {loading ? (
                  <Box
                    sx={{ display: "flex", justifyContent: "center", mt: 5 }}
                  >
                    <CircularProgress />
                  </Box>
                ) : (
                  <TableBody>
                    {filteredData.length === 0 ? (
                      <TableRow>
                        <CardContent>
                          <Typography>No Data Available</Typography>
                        </CardContent>
                      </TableRow>
                    ) : (
                      paginatedData.map((row, index) => (
                        <TableRow
                          key={row.event_id}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <ServiceCard
                            sx={{
                              background: "#f1f1f1",
                              borderLeft: "4px solid transparent",
                              cursor: "pointer",
                              "&:hover": {
                                borderLeft: "4px solid rgb(215, 139, 227)",
                                borderRight: "4px solid rgb(215, 139, 227)",
                                transform: "scale(1)",
                              },
                            }}
                          >
                            <CardContent
                              style={{ flex: "0.8", textAlign: "center" }}
                            >
                              <Typography variant="body2">
                                {index + 1 + page * rowsPerPage}
                              </Typography>
                            </CardContent>
                            <CardContent
                              style={{ flex: "1", textAlign: "center" }}
                            >
                              {getCallerStatusTooltip(row.caller_status)}
                            </CardContent>
                            <CardContent
                              style={{ flex: "2", textAlign: "center" }}
                            >
                              <Typography variant="body2">
                                {row.event_code}
                              </Typography>
                            </CardContent>
                            <CardContent
                              style={{ flex: "1.8", textAlign: "center" }}
                            >
                              <button
                                onClick={() =>
                                  patientIDRequest(row?.patient_id)
                                }
                                style={{
                                  border: "none",
                                  background: "none",
                                  cursor: "pointer",
                                }}
                              >
                                <Typography variant="body2" color="black">
                                  {row.patient_name}
                                </Typography>
                              </button>
                            </CardContent>
                            <CardContent
                              style={{
                                flex: "1.8",
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <CallOutlinedIcon
                                sx={{
                                  color: "#3A974C",
                                  fontSize: "18px",
                                  mr: 0.5,
                                }}
                              />
                              <Typography variant="body2">
                                {row.patient_number}
                              </Typography>
                            </CardContent>
                            <CardContent
                              style={{
                                flex: "1.8",
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <button
                                onClick={() => {
                                  EventIDRequest(row.event_id);
                                  handleOpenDetails2(row);
                                }}
                                style={{
                                  border: "none",
                                  background: "none",
                                  cursor: "pointer",
                                  display: "flex",
                                }}
                              >
                                <Typography variant="body2" color="black">
                                  {row.caller_phone_number}
                                </Typography>
                              </button>
                            </CardContent>
                            <CardContent
                              style={{ flex: 2.8, textAlign: "center" }}
                            >
                              <Typography variant="body2">
                                {row.service_name}
                              </Typography>
                            </CardContent>
                            <CardContent
                              style={{
                                flex: "2",
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <CalendarMonthOutlinedIcon
                                sx={{
                                  color: " #69A5EB",
                                  fontSize: "18px",
                                  mr: 0.5,
                                }}
                              />
                              <Typography variant="body2">
                                {formatDate(row.event_start_date)}
                              </Typography>
                            </CardContent>
                            <CardContent
                              style={{ flex: "1", textAlign: "center" }}
                            >
                              <Typography variant="body2">
                                {row.patient_zone}
                              </Typography>
                            </CardContent>
                            <CardContent
                              style={{ flex: "1", textAlign: "center" }}
                            >
                              <IconButton
                                onClick={(event) => {
                                  EventIDRequest(row.event_id);
                                  handleClick(event);
                                }}
                              >
                                <MoreHorizIcon />
                              </IconButton>
                            </CardContent>
                          </ServiceCard>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                )}
              </Table>
            </TableContainer>

            <TablePagination
              sx={{ overflowY: "hidden" }}
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={filteredData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </>
        ) : selected === "package" ? (
          <Suspense fallback={<CircularProgress />}>
            <PackageServiceTable
              accessToken={accessToken}
              accessHospitalID={accessHospitalID}
              selectedDate={selectedDate}
              selectedService={selectedService}
              selectedCallerStatus={selectedCallerStatus}
              page={page}
              rowsPerPage={rowsPerPage}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              // 🔴 Action props yahan pass karein
              onAllocate={getPackageRequestAllocation}
              onFollowup={handlePackageFollowup}
            />
          </Suspense>
        ) : null}

        {/* Modals... */}
        <Modal open={openPatientDetails} onClose={handleClosePatientDetails}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "90%", sm: 400 },
              bgcolor: "background.paper",
              borderRadius: "12px",
              overflow: "hidden", // IMPORTANT: AppBar ke corners cut hone se bachata hai
              boxShadow: 24,
              outline: "none",
            }}
          >
            {/* AppBar ab full width lega kyunki Box mein p:0 hai */}
            <AppBar
              position="static"
              sx={{
                background: "rgb(237, 204, 242)",
                height: "3.5rem",
                boxShadow: "none",
              }}
            >
              <Toolbar
                sx={{
                  minHeight: "3.5rem",
                  display: "flex",
                  justifyContent: "space-between",
                  px: 2,
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 700, color: "#000" }}
                >
                  PATIENT DETAILS
                </Typography>
                <IconButton
                  onClick={handleClosePatientDetails}
                  sx={{ color: "#000" }}
                >
                  <CloseIcon />
                </IconButton>
              </Toolbar>
            </AppBar>

            {/* Content Area */}
            <Box sx={{ p: 2, maxHeight: "70vh", overflowY: "auto" }}>
              <PatientView
                patientID={patientID}
                ptnID={patientID}
                ptnData={patient}
                hospData={hospital}
                open={openPatientDetails}
                onClose={handleClosePatientDetails}
              />
            </Box>
          </Box>
        </Modal>

        {/* Caller Details Modal */}
        <Modal open={openDetails} onClose={handleCloseDetails2}>
          <Box sx={{ ...style, p: 0, overflow: "hidden" }}>
            <AppBar
              position="static"
              sx={{ background: "rgb(237, 204, 242)", height: "3rem" }}
            >
              <Toolbar
                sx={{
                  minHeight: "3rem",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 600, color: "#000" }}
                >
                  CALLER DETAILS
                </Typography>
                <IconButton onClick={handleCloseDetails2}>
                  <CloseIcon />
                </IconButton>
              </Toolbar>
            </AppBar>
            <Box sx={{ p: 2 }}>
              <CallerView
                callerID={callerId}
                callerNumber={callerNumber}
                eveID={eventID}
                callerName={clrName}
                reqCallerData={caller}
                onClose={handleCloseDetails2}
                flag={2}
              />
            </Box>
          </Box>
        </Modal>

        {/* Followup Modal */}
        <Modal open={open1} onClose={handleClose1}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "95%", sm: 500 },
              bgcolor: "background.paper",
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: 24,
              outline: "none",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* AppBar */}
            <AppBar
              position="static"
              sx={{
                background: "rgb(237, 204, 242)",
                height: "3.5rem",
                boxShadow: "none",
              }}
            >
              <Toolbar
                sx={{
                  minHeight: "3.5rem",
                  display: "flex",
                  justifyContent: "space-between",
                  px: 2,
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 700, color: "#000" }}
                >
                  FOLLOW UP
                </Typography>
                <IconButton onClick={handleClose1} sx={{ color: "#000" }}>
                  <CloseIcon />
                </IconButton>
              </Toolbar>
            </AppBar>

            {/* Content Area */}
            <Box sx={{ p: 3, maxHeight: "70vh", overflowY: "auto" }}>
              <Followup
                sendData={preFollowup}
                enqData={enqID}
                onClose={handleClose1}
                flag={2}
              />
            </Box>
          </Box>
        </Modal>

        {/* Dropdown Menu */}
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          PaperProps={{ style: { width: "15ch" } }}
        >
          <MenuItem
            onClick={() => {
              getEventIDRequest(eventID, paydone);
              handleClose();
            }}
          >
            Allocate
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleOpen1();
              findPreFollowupRecords(eventID);
              handleClose();
            }}
          >
            Followup
          </MenuItem>
        </Menu>
      </Box>
      <Footer />
    </>
  );
};

export default ServiceRequest;
